// extracted by mini-css-extract-plugin
export default {"content":"ModalLoader_content__nHsxq"};